<template>
	<div :class="['text-sm py-1 flex items-start hover:bg-base-100 rounded px-2', changeClass, goal.isSubgoal() ? 'ml-6' : '', goal.isSubgoal() && goal.muted ? 'opacity-40' : '']">
		<!-- <label class="swap" v-if="action === 'import' || action === 'select'">
			<input type="checkbox" class="checkbox checkbox-sm" name="gcb[]" :checked="checked" @change="toggleSelect($event, goal)" />
			<div class="swap-off btn btn-xs btn-primary btn-circle mt-1 mr-2">
				<PlusIcon class="w-4 h-4" />
			</div>
			<div class="swap-on btn btn-xs btn-circle btn-outline mt-1 mr-2">
				<CheckIcon class="w-4 h-4" />
			</div>
		</label> -->
		<label v-if="action === 'import' || action === 'select'">
			<!-- A subgoal always travels with its parent; its checkbox does not add or remove
			     it but decides whether it arrives muted (unchecked) or included (checked). -->
			<input
				type="checkbox"
				class="checkbox checkbox-sm mt-1.5 mr-4"
				name="gcb[]"
				:checked="checked"
				@change="toggleSelect($event, goal)"
			/>
		</label>

		<div
			class="w-20 shrink-0 py-1 mt-0.5 overflow-hidden whitespace-nowrap text-ellipsis mr-2"
			:title="goal.fullPath"
		>
			{{ goal.fullPath }}
		</div>
		<div class="grow whitespace-pre-wrap py-1 mt-0.5">
			<!-- <span v-if="!goal.customTitle || action !== 'select'" :class="[goal.customTitle? 'block line-through text-base-content-light font-normal' : '']"
				v-html="goal.highlightedTitle ? goal.highlightedTitle : goal.title">
			</span> -->
			<span
				class="mr-1"
				:class="[
					goal.customTitle ? 'line-through text-base-content-light font-normal' : '',
					goal.customTitle && action === 'select'
						? 'inline-block w-16 whitespace-nowrap text-ellipsis overflow-clip'
						: '',
				]"
			>
				<span v-if="highlightedTitle" :title="goal.title" v-html="highlightedTitle"></span>
				<span v-else :title="goal.title" v-text="goal.title"></span>
			</span>
			<span v-if="goal.customTitle && highlightedCustomTitle" v-html="highlightedCustomTitle"></span>
			<span v-else-if="goal.customTitle && !highlightedCustomTitle" v-text="goal.customTitle"></span>
			<GoalInfoDropdown v-if="goal.info" :info="goal.info" />
			<div v-if="withTags && goal.tags?.length" class="flex gap-2 mt-1">
				<Tag v-for="tag in goal.tags" class="tag-xs">{{ tag }}</Tag>
			</div>
		</div>
		<div>
			<template v-if="goal.pendingSync !== null">
				<span v-if="goal.pendingSync" class="loading loading-spinner loading-xs mr-2 mt-1"></span>
				<CheckIcon v-else-if="goal.id" v-text="'✅'" class="w-4 h-4 mr-2 mt-1"></CheckIcon>
			</template>
			<!-- A subgoal cannot be removed on its own; removing the parent takes it along. -->
			<div v-else-if="action === 'edit' && goal.id && !goal.isSubgoal()" class="flex gap-2">
				<span v-if="goal.pendingSync" class="loading loading-spinner loading-xs mr-2 mt-2"></span>
				<template v-else>
					<!-- <button class="btn btn-sm btn-ghost btn-circle bg-base-100" @click="handleGoalEditRequest(goal)">
						<PencilIcon class="w-4 h-4"></PencilIcon>
					</button> -->
					<button class="btn btn-sm btn-ghost btn-circle bg-base-100" @click="handleGoalRemoveRequest(goal)">
						<TrashIcon class="w-4 h-4"></TrashIcon>
					</button>
				</template>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { PencilIcon, TrashIcon, PlusIcon, CheckIcon } from "@heroicons/vue/24/outline";
import Tag from "@/components/ui/Tag.vue";
import GoalInfoDropdown from "@/components/GoalInfoDropdown.vue";
import { GoalSearchResult } from "@/stores/Goals.store";
import { Goal } from "@/models/Goal.model";

export default {
	emits: ["request-edit", "request-removal", "checked", "unchecked"],

	props: {
		listItem: {
			type: [Goal, GoalSearchResult], // actually it is expected to always be a GoalSearchResult
			required: true,
		},
		action: {
			type: String,
			default: "edit",
			validates: (value) => ["edit", "import", "select"].includes(value),
		},
		checked: {
			type: Boolean,
			default: () => false,
		},
		withTags: {
			type: Boolean,
			default: true,
		},
		changed: {
			type: [Boolean, String],
			default: false,
		},
	},

	components: {
		PencilIcon,
		TrashIcon,
		PlusIcon,
		CheckIcon,
		Tag,
		GoalInfoDropdown,
	},

	computed: {
		changeClass() {
			if (!this.changed) return "";
			if (this.changed === "added") return "bg-success/10 hover:bg-success/15";
			if (this.changed === "removed") return "bg-warning/10 line-through text-base-content-light";
			return "";
		},
		goal() {
			return this.listItem instanceof GoalSearchResult ? this.listItem.goal : this.listItem;
		},
		highlightedTitle() {
			return this.listItem instanceof GoalSearchResult ? this.listItem.highlightedTitle : null;
		},
		highlightedCustomTitle() {
			return this.listItem instanceof GoalSearchResult ? this.listItem.highlightedCustomTitle : null;
		},
	},

	methods: {
		handleGoalEditRequest(goal: Goal) {
			this.$emit("request-edit", goal);
		},

		handleGoalRemoveRequest(goal: Goal) {
			this.$emit("request-removal", goal);
		},

		toggleSelect(event, goal: Goal) {
			if (event.target.checked) {
				this.$emit("checked", goal);
			} else {
				this.$emit("unchecked", goal);
			}
		},
	},
};
</script>
